__turbopack_context__.v({
  "active": "ProductCardGrid-module__Hqeibq__active",
  "cardBackgroundGradient": "ProductCardGrid-module__Hqeibq__cardBackgroundGradient",
  "cardGrid": "ProductCardGrid-module__Hqeibq__cardGrid",
  "cardGridVertical": "ProductCardGrid-module__Hqeibq__cardGridVertical",
  "cardImage": "ProductCardGrid-module__Hqeibq__cardImage",
  "cardImageFloat": "ProductCardGrid-module__Hqeibq__cardImageFloat",
  "cardInfo": "ProductCardGrid-module__Hqeibq__cardInfo",
  "cardItem": "ProductCardGrid-module__Hqeibq__cardItem",
  "cardTitle": "ProductCardGrid-module__Hqeibq__cardTitle",
  "discountBadge": "ProductCardGrid-module__Hqeibq__discountBadge",
  "discountCornerRibbon": "ProductCardGrid-module__Hqeibq__discountCornerRibbon",
  "discountCornerRibbonStrip": "ProductCardGrid-module__Hqeibq__discountCornerRibbonStrip",
  "navButton": "ProductCardGrid-module__Hqeibq__navButton",
  "navButtonLeft": "ProductCardGrid-module__Hqeibq__navButtonLeft",
  "navButtonRight": "ProductCardGrid-module__Hqeibq__navButtonRight",
  "outOfStockBadge": "ProductCardGrid-module__Hqeibq__outOfStockBadge",
  "sliderCard": "ProductCardGrid-module__Hqeibq__sliderCard",
  "sliderContainer": "ProductCardGrid-module__Hqeibq__sliderContainer",
  "sliderTrack": "ProductCardGrid-module__Hqeibq__sliderTrack",
  "sliderTrackCentered": "ProductCardGrid-module__Hqeibq__sliderTrackCentered",
  "starRow": "ProductCardGrid-module__Hqeibq__starRow",
  "wishlistHeart": "ProductCardGrid-module__Hqeibq__wishlistHeart",
});
